<template>

        <div class="lines-wrap">
            <div class="lines-inner">
                <div class="lines"></div>
            </div>
        </div>
        <!-- END lines -->

        <div class="site-mobile-menu site-navbar-target">
            <div class="site-mobile-menu-header">
                <div class="site-mobile-menu-close">
                    <span class="icofont-close js-menu-toggle"></span>
                </div>
            </div>
            <div class="site-mobile-menu-body"></div>
        </div>

















        <!-- <div id="overlayer"></div>
   <div class="loader">
      <div class="spinner-border" role="status">
         <span class="sr-only">Loading...</span>
      </div>
   </div> -->
</template>

<script>
import Header from './Header.vue';

export default {
    name: "ProjectTemplate1",
    components: {
        Header
    }
}
</script>

<style></style>